import { Item as _Item } from '@studio/design-system/dropdown-menu';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ItemProps } from '../../types.js';

/** Hive/PTZOptics vendor menu `<Item>` component without badges, status, or Ellipses. */
export const ItemHive = ({ className, ...props }: ItemProps): ReactElement => (
  <_Item className={twMerge('h-34 border-b-0 text-md', className)} {...props} />
);
